export const MODAL_CAJA_VISIBLE = 'MODAL_CAJA_VISIBLE';
export const MODAL_CAJA_OCULTO = 'MODAL_CAJA_OCULTO';
export const SET_VISIBLE = 'SET_VISIBLE_CAJA';
export const SET_ALERT = 'SET_ALERT';

